import React, { useState, useContext, useEffect, useRef } from 'react';

import {
	Typography,
	Stack,
	Paper,
	Grid,
	TableContainer,
	Table,
	TableHead,
	TableRow,
	TableCell,
	TableBody,
	TextField,
	Button,
	Container
} from '@mui/material';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint, faSave } from '@fortawesome/free-solid-svg-icons';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import ReactToPrint from 'react-to-print';

import { DataContext } from '../../../../context/DataContext';

import {
	getDataLiquidacionAsync,
	getVacacionesAsync,
	liquidarEmpleadoAsync
} from '../../../../api/Employees';
import { getToken } from '../../../../api/Account';
import { simpleMessage } from '../../../../helpers/Helpers';
import { PrintReport } from '../../../../components/PrintReport';
import { conv2Letras } from '../../../../helpers/n2Letras';

const labelStyle = { color: '#2979ff', fontSize: 12, flex: 1, textAlign: 'left' };
const valueStyle = { fontSize: 12, flex: 2, textAlign: 'left' };

const formatCurrency = (value) =>
	new Intl.NumberFormat('es-NI', {
		style: 'currency',
		currency: 'NIO'
	}).format(value);

// Format date consistently
const formatDate = (date) => moment(date).format('L');

const InfoRow = ({ label, value }) => (
	<Stack direction="row" spacing={1} alignItems="left">
		<Typography sx={labelStyle}>{label}</Typography>
		<Typography sx={valueStyle}>{value}</Typography>
	</Stack>
);

const LiquidateEmployee = ({ dataEmployee, setShowModal, reload, setReload }) => {
	const [histoyVac, setHistoryBac] = useState([]);
	const [dataLiquidacion, setDataLiquidacion] = useState([]);
	const [ingresos, setIngresos] = useState([]);
	const [egresos, setEgresos] = useState([]);

	const [montoBono, setMontoBono] = useState(0);

	const [fechaLiquidacion, setFechaLiquidacion] = useState(new Date());

	const { fullName, identification, fechaInicioContrato, salario, id, puesto, inssNumber } =
		dataEmployee;

	const { setIsLoading, setIsUnautorized, representanteLegal } = useContext(DataContext);

	const compRef = useRef();

	useEffect(() => {
		getEmployee();
		getDataLiquidacion(fechaLiquidacion);
	}, [fechaLiquidacion]);

	const token = getToken();

	const getEmployee = async () => {
		setIsLoading(true);
		const result = await getVacacionesAsync(token, dataEmployee.id);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}
		setHistoryBac(result.data.result);
		setIsLoading(false);
	};

	const getDataLiquidacion = async (fechaLiquidacion) => {
		setIsLoading(true);
		const data = {
			employeeId: dataEmployee.id,
			fechaLiquidacion: new Date(fechaLiquidacion).toISOString()
		};
		const result = await getDataLiquidacionAsync(token, data);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}
		// console.log(result.data.result);
		setDataLiquidacion(result.data.result);
		setIngresos(result.data.result.liquidacionDetails.filter((item) => !item.isDeduccion));
		setEgresos(result.data.result.liquidacionDetails.filter((item) => item.isDeduccion));
		setIsLoading(false);
	};

	const setMontoBonoFunc = (value, row) => {
		if (/^\d*\.?\d*$/.test(value.toString()) || value === '') {
			setMontoBono(value);
			row.valor = parseFloat(value === '' ? 0 : value);
		}
	};

	const getTotal = (detalle) => {
		let result = 0;
		if (detalle === undefined || detalle.length === 0) {
			return result;
		}
		detalle.map((item) => {
			result += item.valor;
		});

		return result;
	};

	const liquidarEmployee = async () => {
		const datos = {
			employeeId: dataEmployee.id,
			antiguedad: histoyVac.antiguedad,
			vacaionesDisponibles: histoyVac.saldoVac,
			salarioBasico: salario,
			fechaLiquidacion: new Date(fechaLiquidacion).toISOString(),
			liquidacionDetails: dataLiquidacion.liquidacionDetails
		};

		setIsLoading(true);
		const result = await liquidarEmpleadoAsync(token, datos);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}
		setIsLoading(false);
		simpleMessage('Empleado Liquidado...!', 'success');
		setReload(!reload);
		setShowModal(false);
	};

	const pageStyle = `
	@media print {
	  html, body {
		height: initial !important;
		overflow: initial !important;
		-webkit-print-color-adjust: exact;
	  }
	}
	@media all {
	  .pagebreak {
		display: none;
	  }
	}
	@media print {
	  .pagebreak {
		page-break-before: always;
	  }
	}  
	@page { size: Letter portrait; margin: 10mm; }
  `;

	const getTotalIE = (detalle) => {
		let result = 0;

		detalle.map((item) => {
			result += item.valor;
		});

		return result;
	};

	return (
		<div>
			<Paper
				style={{
					padding: 20,
					textAlign: 'center'
				}}
			>
				<Stack
					direction={'row'}
					display="flex"
					justifyContent="space-between"
					alignItems="center"
				>
					<Typography color={'#00a152'} textAlign={'left'} fontWeight={'bold'}>
						Datos del empleaado
					</Typography>
					<Stack direction={'row'} alignItems="center" spacing={1}>
						<DesktopDatePicker
							closeOnSelect
							label="Fecha Liquidacion"
							inputFormat="DD/MM/YYYY"
							value={fechaLiquidacion}
							onChange={(newValue) => setFechaLiquidacion(newValue)}
							renderInput={(params) => <TextField {...params} />}
						/>
					</Stack>
				</Stack>

				<hr />
				<Grid container spacing={1}>
					<Grid item xs={6}>
						<Stack spacing={1}>
							<InfoRow label="EMPLEADO:" value={`${id} - ${fullName}`} />
							<InfoRow label="Cargo:" value={puesto?.description} />
							<InfoRow label="Salario:" value={formatCurrency(salario)} />
							<InfoRow label="Seguro Social:" value={inssNumber} />
						</Stack>
					</Grid>

					<Grid item xs={6}>
						<Stack spacing={1}>
							<InfoRow label="Antigüedad:" value={histoyVac.antiguedad} />
							<InfoRow
								label="Fecha ingreso:"
								value={formatDate(fechaInicioContrato)}
							/>
							<InfoRow label="Fecha Baja:" value={formatDate(fechaLiquidacion)} />
							<InfoRow label="Fecha Emisión:" value={formatDate(new Date())} />
						</Stack>
					</Grid>
				</Grid>
			</Paper>

			{dataLiquidacion.length === 0 ? (
				<></>
			) : (
				<Paper
					style={{
						marginTop: 10,
						padding: 20
					}}
				>
					<Typography color={'#00a152'} textAlign={'left'} fontWeight={'bold'}>
						Detalle Liquidacion
					</Typography>

					<hr />
					<div
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							marginBottom: '20px'
						}}
					>
						<div
							style={{
								width: '48%'
							}}
						>
							<Stack
								direction={'row'}
								spacing={1}
								justifyContent="space-between"
								flex={1}
								sx={{ borderBottom: '1px solid #000' }}
							>
								<h6
									style={{
										fontWeight: 'bold',

										paddingBottom: '5px'
									}}
								>
									INGRESOS
								</h6>
								<p
									style={{
										textAlign: 'right',
										fontWeight: 'bold',
										fontSize: 15
									}}
								>
									{new Intl.NumberFormat('es-NI', {
										style: 'currency',
										currency: 'NIO'
									}).format(getTotalIE(ingresos))}
								</p>
							</Stack>

							<table
								style={{
									width: '100%'
								}}
							>
								<tbody>
									{ingresos.map((item) => {
										return (
											<tr key={item.detalle}>
												<td style={{ fontSize: 12 }}>{item.detalle}</td>
												<td
													style={{
														textAlign: 'right',
														fontSize: 12
													}}
												>
													{new Intl.NumberFormat('es-NI', {
														style: 'currency',
														currency: 'NIO'
													}).format(item.valor)}
												</td>
											</tr>
										);
									})}
								</tbody>
							</table>
						</div>

						<div
							style={{
								width: '48%'
							}}
						>
							<Stack
								direction={'row'}
								spacing={1}
								justifyContent="space-between"
								flex={1}
								sx={{ borderBottom: '1px solid #000' }}
							>
								<h6
									style={{
										fontWeight: 'bold',

										paddingBottom: '5px'
									}}
								>
									DEDUCCIONES
								</h6>
								<p
									style={{
										textAlign: 'right',
										fontWeight: 'bold',
										fontSize: 15
									}}
								>
									{new Intl.NumberFormat('es-NI', {
										style: 'currency',
										currency: 'NIO'
									}).format(getTotalIE(egresos))}
								</p>
							</Stack>

							<table
								style={{
									width: '100%'
								}}
							>
								<tbody>
									{egresos.map((item) => {
										return (
											<tr key={item.detalle}>
												<td style={{ fontSize: 12 }}>{item.detalle}</td>
												<td
													style={{
														textAlign: 'right',
														fontSize: 12
													}}
												>
													{new Intl.NumberFormat('es-NI', {
														style: 'currency',
														currency: 'NIO'
													}).format(item.valor)}
												</td>
											</tr>
										);
									})}
								</tbody>
							</table>
						</div>
					</div>

					<div
						style={{
							width: '48%'
						}}
					>
						<Stack
							direction={'row'}
							spacing={1}
							justifyContent="space-between"
							flex={1}
						>
							<h6
								style={{
									fontWeight: 'bold',
									paddingBottom: '5px'
								}}
							>
								NETO A RECIBIR
							</h6>
							<p
								style={{
									textAlign: 'right',
									fontWeight: 'bold',
									fontSize: 15
								}}
							>
								{new Intl.NumberFormat('es-NI', {
									style: 'currency',
									currency: 'NIO'
								}).format(getTotalIE(ingresos) - getTotalIE(egresos))}
							</p>
						</Stack>
					</div>
				</Paper>
			)}

			<Stack direction={'row'} spacing={1} style={{ marginTop: 20 }}>
				<Button
					variant="outlined"
					startIcon={<FontAwesomeIcon icon={faSave} style={{ marginRight: 20 }} />}
					fullWidth
					onClick={() => liquidarEmployee()}
					style={{
						borderRadius: 20,
						color: '#00a152',
						borderColor: '#00a152'
					}}
					size="large"
				>
					Liquidar Empleado
				</Button>

				<ReactToPrint
					trigger={() => {
						return (
							<Button
								variant="outlined"
								startIcon={
									<FontAwesomeIcon icon={faPrint} style={{ marginRight: 20 }} />
								}
								fullWidth
								style={{
									borderRadius: 20,
									color: '#2979ff',
									borderColor: '#2979ff'
								}}
								size="large"
							>
								Imprimir Comprobante
							</Button>
						);
					}}
					content={() => compRef.current}
					pageStyle={pageStyle}
				/>
			</Stack>

			<div
				style={{
					display: 'none'
				}}
			>
				<PrintReport ref={compRef} titulo={'HOJA DE LIQUIDACION'}>
					<Container maxWidth={false} sx={{ textAlign: 'center' }}>
						<hr />
						<Grid container spacing={1}>
							<Grid item xs={6}>
								<Stack spacing={1}>
									<InfoRow label="EMPLEADO:" value={`${id} - ${fullName}`} />
									<InfoRow label="Cargo:" value={puesto?.description} />
									<InfoRow label="Salario:" value={formatCurrency(salario)} />
									<InfoRow label="Seguro Social:" value={inssNumber} />
								</Stack>
							</Grid>

							<Grid item xs={6}>
								<Stack spacing={1}>
									<InfoRow label="Antigüedad:" value={histoyVac.antiguedad} />
									<InfoRow
										label="Fecha ingreso:"
										value={formatDate(fechaInicioContrato)}
									/>
									<InfoRow
										label="Fecha Baja:"
										value={formatDate(fechaLiquidacion)}
									/>
									<InfoRow
										label="Fecha Emisión:"
										value={formatDate(new Date())}
									/>
								</Stack>
							</Grid>
						</Grid>
						{dataLiquidacion.length === 0 ? (
							<></>
						) : (
							<>
								<hr />
								<div
									style={{
										display: 'flex',
										justifyContent: 'space-between',
										marginBottom: '20px'
									}}
								>
									<div
										style={{
											width: '48%'
										}}
									>
										<Stack
											direction={'row'}
											spacing={1}
											justifyContent="space-between"
											flex={1}
											sx={{ borderBottom: '1px solid #000' }}
										>
											<h6
												style={{
													fontWeight: 'bold',

													paddingBottom: '5px'
												}}
											>
												INGRESOS
											</h6>
											<p
												style={{
													textAlign: 'right',
													fontWeight: 'bold',
													fontSize: 15
												}}
											>
												{new Intl.NumberFormat('es-NI', {
													style: 'currency',
													currency: 'NIO'
												}).format(getTotalIE(ingresos))}
											</p>
										</Stack>

										<table
											style={{
												width: '100%'
											}}
										>
											<tbody>
												{ingresos.map((item) => {
													return (
														<tr key={item.detalle}>
															<td
																style={{
																	fontSize: 12,
																	textAlign: 'left'
																}}
															>
																{item.detalle}
															</td>
															<td
																style={{
																	textAlign: 'right',
																	fontSize: 12
																}}
															>
																{new Intl.NumberFormat('es-NI', {
																	style: 'currency',
																	currency: 'NIO'
																}).format(item.valor)}
															</td>
														</tr>
													);
												})}
											</tbody>
										</table>
									</div>

									<div
										style={{
											width: '48%'
										}}
									>
										<Stack
											direction={'row'}
											spacing={1}
											justifyContent="space-between"
											flex={1}
											sx={{ borderBottom: '1px solid #000' }}
										>
											<h6
												style={{
													fontWeight: 'bold',
													paddingBottom: '5px'
												}}
											>
												DEDUCCIONES
											</h6>
											<p
												style={{
													textAlign: 'right',
													fontWeight: 'bold',
													fontSize: 15
												}}
											>
												{new Intl.NumberFormat('es-NI', {
													style: 'currency',
													currency: 'NIO'
												}).format(getTotalIE(egresos))}
											</p>
										</Stack>

										<table
											style={{
												width: '100%'
											}}
										>
											<tbody>
												{egresos.map((item) => {
													return (
														<tr key={item.detalle}>
															<td
																style={{
																	fontSize: 12,
																	textAlign: 'left'
																}}
															>
																{item.detalle}
															</td>
															<td
																style={{
																	textAlign: 'right',
																	fontSize: 12
																}}
															>
																{new Intl.NumberFormat('es-NI', {
																	style: 'currency',
																	currency: 'NIO'
																}).format(item.valor)}
															</td>
														</tr>
													);
												})}
											</tbody>
										</table>
									</div>
								</div>
							</>
						)}
						<div
							style={{
								width: '48%'
							}}
						>
							<Stack
								direction={'row'}
								spacing={1}
								justifyContent="space-between"
								flex={1}
							>
								<h6
									style={{
										fontWeight: 'bold',
										paddingBottom: '5px'
									}}
								>
									NETO A RECIBIR
								</h6>
								<p
									style={{
										textAlign: 'right',
										fontWeight: 'bold',
										fontSize: 15
									}}
								>
									{new Intl.NumberFormat('es-NI', {
										style: 'currency',
										currency: 'NIO'
									}).format(getTotalIE(ingresos) - getTotalIE(egresos))}
								</p>
							</Stack>
						</div>
						<div
							style={{
								marginBottom: '20px',
								border: '1px solid #000',
								padding: '10px',
								fontSize: 12,
								textAlign: 'justify'
							}}
						>
							<p>
								Estoy conforme de RECIBIR la suma de CS
								{`${new Intl.NumberFormat('es-NI', {
									style: 'currency',
									currency: 'NIO'
								}).format(
									getTotal(dataLiquidacion.liquidacionDetails)
								)} (${conv2Letras(
									getTotal(dataLiquidacion.liquidacionDetails)
								)}).`}{' '}
								en concepto de cancelación de todas mis prestaciones sociales
								acumuladas a la fecha a las que tengo derecho de acuerdo a la ley
								laboral vigente. Declaro no tener reclamo alguno con el finiquito.
								Firmo en pleno ejercicio de mis derechos.
							</p>
						</div>
						<Stack direction={'row'} justifyContent="space-between" marginTop={10}>
							<Stack>
								<Typography textAlign="center" fontSize={12}>
									_________________________________________
								</Typography>
								<Typography textAlign="left" fontSize={8}>
									Recibi conforme
								</Typography>
								<Typography textAlign="center" fontSize={12}>
									{fullName}
								</Typography>
								<Typography textAlign="center" fontSize={12}>
									{identification}
								</Typography>
							</Stack>

							<Stack>
								<Typography textAlign="center" fontSize={12}>
									_________________________________________
								</Typography>
								<Typography textAlign="left" fontSize={8}>
									Autorizado por
								</Typography>
								<Typography textAlign="center" fontSize={12}>
									{representanteLegal}
								</Typography>
							</Stack>
						</Stack>
					</Container>
				</PrintReport>
			</div>
		</div>
	);
};

export default LiquidateEmployee;
